var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 18,
    viewBox: "0 0 28 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8813 7.575C22.8813 7.5 22.8937 7.425 22.8937 7.35C22.8937 3.2875 19.6562 0 15.6625 0C12.7812 0 10.3063 1.7125 9.14375 4.1875C8.6375 3.93125 8.06875 3.78125 7.46875 3.78125C5.625 3.78125 4.0875 5.15 3.79375 6.9375C1.58125 7.7 0 9.81875 0 12.3125C0 15.45 2.50625 18 5.59375 18H12V13H8.9875L14 7.76875L19.0125 12.9937H16V17.9937H22.8937C25.7188 17.9937 28 15.65 28 12.7812C28 9.9125 25.7063 7.58125 22.8813 7.575Z",
    fill: "#1C50A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadicon);
export default __webpack_public_path__ + "static/media/upload icon.19cecbe3e238835be3f2e54458e2908e.svg";
export { ForwardRef as ReactComponent };